import React from 'react';
import ModalContentWrapper from '../ModalContentWrapper';
import "./ModalProvideFeedback.scss";

const ModalProvideFeedback = (props) =>
{
    const onClickCancel = () =>
    {
        props.onClose() ;
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            <h3>Provide Feedback</h3>

            <div style={{width: '600px', marginTop: '10px'}}>
                <p>We would love to hear of any suggestions you have that could improve ARCBOX or if you have encountered any problems.</p>
                <p style={{marginTop: '10px'}}>Please email ARCBOX using <a href="mailto:info@arcbox.co.uk" style={{color: '#038fde'}}>info@arcbox.co.uk</a> and we will get back to you as soon as possible.</p>
            </div>

            <div className="d-flex flex-row justify-content-end">
                <div className="p-2"><button onClick={onClickCancel} className="btn btn-secondary nutritroops-btn-secondary">Cancel<i className="et-arrow-bold-left"></i></button></div>
            </div>
        </ModalContentWrapper>
    )
}

export default ModalProvideFeedback;
